/* eslint-disable @typescript-eslint/no-this-alias */
/* eslint-disable no-useless-escape */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/*jshint esversion: 6 */

// Plugin Name:		MINDGALLERY
// Plugin URI:		https://mindfolio.webmajstr.cz/mindgallery
// Description:		Smooth Gallery carefully crafted for Mindfolio WP Theme
// Author:			Jakub Runda
// Author URI:		http://webmajstr.cz
// Version:			1.9.5

import { Mg_Icons } from './mg_icons_obj';

export default function mind_gallery(settings) {

	if (settings == false) {
		return;
	}


	this.isMobile = false;
	this.$window = jQuery(window);
	this.mg = this;
	this.$mg_container = jQuery(settings.container);

	this.$Shelf = null; //.mind-items

	this.$thumbnails = null;
	this.$controls = null;
	this.$nav_container = null;
	this.$canvas = null;
	this.$info_container = null;
	this.$info_container_collapse = null;
	this.$init_blank_window = null;

	this.$items = null;
	this.$item_length = null;

	this.$active_layer = null;
	this.$inactive_layer = null;

	this.controls_collapsed = false;
	this.player = false;
	this.lightbox_collapsed = true;

	this.$arrow_left = null;
	this.$arrow_right = null;

	this.children = [];
	this.thumbnails_array = [];
	this.settings = settings;
	this.current_item_id = 0;
	this.current_canvas_id = 0;
	this.z_index_bottom = -100;
	this.z_index_top = -90;


	this.shutdown = function () {
		//console.log('gdfgdfg0');
		//restart_scrolling();
		if (this.player)
			this.stop();
		this.$canvas.fadeOut();
		this.lightbox_collapsed = true;
	};
	this.shutup = function () {
		this.direction = '';
		this.$active_layer = this.$lb_layer_water;
		this.$active_layer.css('left', 0);
		this.$lb_layer_earth.css('left', -1 * this.$window.width());
		this.$lb_layer_air.css('left', this.$window.width());
		this.$canvas.fadeIn();
		this.lightbox_collapsed = false;
		//stop_scrolling();
	};

	this.SuperLoader = {
		mg: false,
		children: undefined,
		loading: false,
		items_to_load: [],
		$currently_viewed_item: false,
		init: function (mg) {
			this.mg = mg;
		},

		load_image: function ($item) {

			//console.log('starting to load image '+$item.id);
			var Loader = this;
			Loader.loading = true; //zamkne naÄÃ­tÃ¡nÃ­ jinÃ©ho obrÃ¡zku neÅ¾ toho konkrÃ©tnÃ­ho. OstatnÃ­ obrÃ¡zky se uloÅ¾Ã­ do fronty

			$item.status = 'loading';

			$item.$img
				.on('load', function () {
					$item.status = 'loaded';
					clearInterval($item.$preloader.preloader_int);
					$item.$preloader.fadeOut(function () {
						$item.$preloader.remove();
					});
					$item.$img_thumb.remove();
					Loader.loading = false;
					Loader.load_next();
				})
				.on('error', function () {
					$item.status = 'error';
					clearInterval($item.$preloader.preloader_int);
					$item.$preloader.fadeOut();
					Loader.loading = false;
					Loader.load_next();
				})
				.attr('src', $item.attr('src'))
				.attr('srcset', $item.attr('srcset'))
				.attr('sizes', $item.attr('sizes'));
		},
		seek_what_next: function () {
			// If no image is loading 
			//   looks at the curernt image that is not loading
			//   checks at the next and previous item­
			//   if both are loaded puts Loader to sleep
			//console.log('seeking what next');

			if (!this.loading) {
				if (this.$currently_viewed_item.status == 'loaded' || this.$curently_viewed_item.status == 'error') {
					//console.log('curent image loaded getting sibblings');
					var c_id = this.$currently_viewed_item.id;
					var prev_id = c_id - 1;
					var next_id = c_id + 1;
					if (c_id == 0)
						prev_id = this.mg.$Shelf.length - 1;
					else if (c_id == this.mg.$Shelf.length - 1)
						next_id = 0;

					var $next_item = this.mg.$Shelf_array[next_id];
					var $prev_item = this.mg.$Shelf_array[prev_id];

					var status = 0;
					if ($next_item.status == 'init') {
						this.items_to_load.push($next_item);
						status = 1;
					}
					if ($prev_item.status == 'init') {
						this.items_to_load.push($prev_item);
						status = 1;
					}
					if (status == 1)
						this.load_next();

				}
			} else
				console.log('seeking interrupted - loading in progress');
		},
		load_next: function () {
			if (this.items_to_load.length >= 1) {
				//console.log('Loader has siblings to load');
				var $i = this.items_to_load[0];
				this.items_to_load.shift();
				this.load_image($i);
			} else
				this.seek_what_next();
		},
		item_viewed: function ($item) {
			console.log('item is');
			console.log($item);
			this.$currently_viewed_item = $item;
			if ($item.status == 'init') {
				if (!this.loading) { //pokud zrovna nestahuje Å¾Ã¡dnÃ½ obrÃ¡zek
					this.load_image($item);
				} else {
					this.items_to_load = [$item];
				}
			} else if ($item.status == 'loaded')
				this.load_next();
		}

	};

	this.init = function () {

		if (!this.settings.info)
			this.settings.info_collapse = false;

		var mg = this;

		// SUPER LOADER INITIATION GERE

		this.SuperLoader.init(mg); // Sets the SuperLoader Object


		// In case there is an empty background-mg-holder, creates a gallery in the background
		// it's a feature for the option of having page bacgkround looping a gallery

		var sl = jQuery('#background-mg-holder');
		if (sl && sl.html() == '')
			sl.append(this.$mg_container);


		//Originally this served against blinking, now it seems to be repaired so the div is not there anymore

		this.$init_blank_window = this.$mg_container.find('.mindfolio-blank-window');




		if (this.settings.controls) {

			var image_size = getCookie('image_size');

			if (image_size != '')
				this.settings.image_size = image_size;
		} else {
			this.settings.thumbnails = false;
			this.settings.items_autosize = false;
		}

		this.$thumbnails_holder = jQuery(this.$mg_container.find('.mind-thumbnails')[0]);
		this.$thumbnails = jQuery(this.$mg_container.find('.mind-thumbnails')).children();

		this.$Shelf = jQuery(this.$mg_container.find('.mind-items'));
		this.$Shelf_children = this.$Shelf.children();
		this.$Shelf_array = [];
		this.$Shelf.length = 0;

		this.$Shelf.css('display', 'none'); // moÅ¾nÃ¡ bude lepÅ¡Ã­ nÄ›kam podstrÄit ÃºplnÄ› dozadu se z-indexem -1000 tÅ™eba vyzkouÅ¡et	


		this.$Shelf_children.each(function () {

			// nastavÃ­ objekt $item a vloÅ¾Ã­ jej do pole SHELF_ARRAY			
			var $item = jQuery(mg.$Shelf_children[mg.$Shelf.length]);

			$item.id = mg.$Shelf.length;
			$item.status = 'init';
			$item.type = '';
			$item.$layer = jQuery($item.find('.mind-item-layer'));
			$item.loaded = false;
			$item.order = mg.$Shelf.length;
			$item.$img = jQuery($item.$layer.find('.mind-image'));
			$item.$img_thumb = jQuery($item.$layer.find('.mind-image-thumb'));
			$item.name = jQuery($item.find('.mind-item-content h1')).html();
			$item.desc = jQuery($item.find('.mind-item-content p')).html();
			$item.$preloader = jQuery('<img>', {
				class: 'mind-item-preloader-image',
				src: mg.settings.images_path + 'mind-gallery_loading.gif'
			});


			var $close_background = jQuery('<div>', {
				class: 'mind-shutdown-background'
			});
			$item.$layer.append($close_background);

			$item.$layer.append($item.$preloader);


			$close_background.click(function () {
				mg.shutdown();
			});


			mg.$Shelf_array.push($item);

			// adds preloader			
			$item.$layer.append($item.$preloader);

			$item.$preloader.angle = 0;
			$item.$preloader.preloader_int = setInterval(function () {
				$item.$preloader.angle += 5;
				$item.$preloader.rotate($item.$preloader.angle);
			}, 30);

			// sets image click without the need of adding extra element on top of the image

			$item.$img.click({
				mg: mg
			}, mg.item_image_clicked);


			mg.$Shelf.length++;
		});


		//hides controls for galleries with only one item
		if (this.$Shelf.length <= 1) {
			this.settings.controls = false;
			this.settings.panel_navigation = false;
			//this.settings.arrow_control = false;
		}

		if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4)) || jQuery(window).width() < 701) {

			this.isMobile = true;

			if (this.settings.type == 'background') {
				this.$mg_container.removeClass('mindgallery-type-' + this.settings.type)
					.addClass('mindgallery-type-lightbox');

				this.settings.type = 'lightbox'; // dodÄ›lat special mobile verzi
			}
		}


		switch (this.settings.type) {
		case 'background':
			this.init_fullscreen();
			break;
		case 'lightbox':
			this.init_lightbox();
			break;
		case 'default':
			this.init_default();
			break;
		}



	};

	this.item_image_clicked = function (e) {

		var mg = e.data.mg;

		var img = e.target;
		var $img = jQuery(img);
		var i_w = $img.width();
		var x_pos = e.pageX;
		var img_x_offset = img.getBoundingClientRect().left;

		if (x_pos < img_x_offset + i_w / 2) {
			mg.previous_image(mg);
		} else {
			mg.next_image(mg);
		}
	};
	this.init_fullscreen = function () {

		this.$mg_container.appendTo(jQuery('#background-container'));

		this.$canvas = jQuery('<div>', {
			class: 'mind-canvas'
		});
		this.$canvas.height(this.$mg_container.height());
		this.$canvas.width(this.$mg_container.width());
		this.$mg_container.append(this.$canvas);

		if (this.$mg_container.width() == 0)
			this.$mg_container.width(this.$window.width()).height(this.$window.height());

		if (this.settings.info) {
			if (this.settings.info === true)
				this.$info_container = this.$canvas_container;
			else
				this.$info_container = jQuery(settings.info);
			this.init_info_panel();
		}
		this.$active_layer = jQuery('<div>', {
			class: 'mind-canvas-layer-1'
		});
		this.$inactive_layer = jQuery('<div>', {
			class: 'mind-canvas-layer-2'
		});

		this.$canvas.append(this.$active_layer).append(this.$inactive_layer);

		if (this.settings.panel_navigation)
			this.$mg_container.append(this.init_panel_navigation());


		if (this.settings.arrow_control)
			jQuery(document).keydown({
				mg: this
			}, this.keypressed);



		if (this.settings.controls) {
			this.init_controls();

			if (this.settings.thumbnails) {

				this.init_thumbnails();

				this.thumbnails_array[settings.first_image].get_focus();
				this.thumbnails_array[settings.first_image].deactivate();
			}


			this.controls_collapsed = true;
			this.place_controls(this);

		} else {
			this.$thumbnails.css('display', 'none');
		}

		if (this.settings.autoplay)
			this.player = true;


		this.show_item(settings.first_image, this);
		jQuery(window).resize({
			mg: this
		}, this.mind_resized);
	};
	this.init_default = function () {

		this.settings.info = false;
		this.settings.info_collapse = false;

		if (this.settings.controls) {

			this.init_controls();

			if (this.settings.thumbnails) {

				this.init_thumbnails();

				this.thumbnails_array[settings.first_image].get_focus();

				this.thumbnails_array[settings.first_image].deactivate();
			}

			this.controls_collapsed = true;

		} else {
			this.$thumbnails.css('display', 'none');
		}

		// NOW BUILD THE DOM STRUCTURE AND SET ITS PROPERTIES

		this.$canvas = jQuery('<div>', {
			class: 'mind-canvas'
		});

		this.$canvas.height(this.$mg_container.height());

		this.$canvas.width(this.$mg_container.width());

		this.$mg_container.prepend(this.$canvas);

		this.settings.posts_navigation = false;



		for (var i = 0; i < this.children.length; i++) {

			var $child = this.children[i];

			var $mind_item_layer = jQuery($child.$item.find('.mind-item-layer'));
			//var $img = jQuery($mind_item_layer.find('img'));
			var $mind_item_preloader = jQuery('<div>', {
				class: 'mind-item-preloader'
			});



			var $preloader_image = jQuery('<img>', {
				class: 'mind-item-preloader-image',
				src: this.settings.images_path + 'mg/preloader.png'
			});

			$preloader_image.width(70).height(70);



			$mind_item_preloader.append($preloader_image);
			$mind_item_layer.append($mind_item_preloader);


		}

		this.z_index_bottom = 90;
		this.z_index_top = 100;

		this.$active_layer = jQuery('<div>', {
			class: 'mind-canvas-layer-1'
		});
		this.$inactive_layer = jQuery('<div>', {
			class: 'mind-canvas-layer-2'
		});



		this.$canvas.append(this.$active_layer).append(this.$inactive_layer);

		if (this.settings.panel_navigation)
			this.$mg_container.append(this.init_panel_navigation());


		if (this.settings.arrow_control)
			jQuery(document).keydown({
				mg: this
			}, this.keypressed);




		if (this.settings.autoplay)
			this.player = true;


		this.show_item(settings.first_image, this);
		jQuery(window).resize({
			mg: this
		}, this.mind_resized);
	};

	this.init_mobile = function () {


		for (var i = 0; i < this.children.length; i++) {

			var $child = this.children[i];

			var $mind_item_layer = jQuery($child.$item.find('.mind-item-layer'));
			//var $img = jQuery($mind_item_layer.find('img'));
			var $mind_item_preloader = jQuery('<div>', {
				class: 'mind-item-preloader'
			});



			var $preloader_image = jQuery('<img>', {
				class: 'mind-item-preloader-image',
				src: this.settings.images_path + 'mg/preloader.png'
			});

			$preloader_image.width(70).height(70);


			$mind_item_preloader.append($preloader_image);
			$mind_item_layer.append($mind_item_preloader);


		}

		this.$active_layer = jQuery('<div>', {
			class: 'mind-canvas-layer-1'
		});
		this.$inactive_layer = jQuery('<div>', {
			class: 'mind-canvas-layer-2'
		});



		this.$canvas.append(this.$active_layer).append(this.$inactive_layer);

		if (this.settings.panel_navigation)
			this.$mg_container.append(this.init_panel_navigation());

	};
	this.init_lightbox = function () {
		var mg = this;
		mg.settings.controls = false;
		mg.settings.posts_navigation = false;

		mg.settings.image_size = 'no_scale';

		this.$lb_active = false;

		this.$canvas = jQuery('<div>', {
			class: 'lb-canvas'
		});

		this.$close_button = jQuery('<div>', {
			class: 'mind-shutdown-button button'
		});

		this.$lb_layer_earth = jQuery('<div>', {
			class: 'lb-layer earth'
		});
		this.$lb_layer_water = jQuery('<div>', {
			class: 'lb-layer water'
		});
		this.$lb_layer_air = jQuery('<div>', {
			class: 'lb-layer air'
		});

		this.$canvas
			.append(this.$close_button)
			.append(this.$lb_layer_earth)
			.append(this.$lb_layer_water)
			.append(this.$lb_layer_air);

		this.$mg_container.append(this.$canvas);

		this.init_thumbnails();
		this.init_buttons_navigation();

		this.$close_button.click(function () {
			mg.shutdown();
		});

		jQuery(window).resize({
			mg: this
		}, this.lb_resize);


		if (this.settings.arrow_control)
			jQuery(document).keydown({
				mg: this
			}, this.lightbox_keypressed);

	};
	this.lb_resize = function (e) {
		var mg = e.data.mg;
		mg.prepare_item(mg, mg.current_item_id);

	};
	this.activate_lightbox = function () {

		this.direction = '';
		this.$active_layer = this.lb_layer_water;

		this.stop_scrolling();
		if (background_mg)
			background_mg.stop();
	};

	this.init_thumbnails = function () {


		for (var i = 0; i < this.$Shelf.length; i++) {

			var thumb = new this.thumb(this, i);
			thumb.activate();
			this.thumbnails_array.push(thumb);
		}

	};

	this.init_panel_navigation = function () {
		var $nav = jQuery('<div>', {
			class: 'mind-nav'
		});

		var $left_panel = jQuery('<div>', {
			class: 'mind-nav_left'
		});
		var $right_panel = jQuery('<div>', {
			class: 'mind-nav_right'
		});
		var c_h = this.$canvas.height();

		$nav.height(c_h);
		$left_panel.height(c_h);
		$right_panel.height(c_h);

		var $panel_buttons_navigation = jQuery('<div>', {
			class: 'panel-navigation-button-holder '
		});

		this.$nav_button_left = this.mind_button_svg(

			Mg_Icons.arrow_left,
			{
				class: 'panel-navigation-button',
				w: 120,
				h: 120
			}
		);


		this.$nav_button_right = this.mind_button_svg(

			Mg_Icons.arrow_right,
			{
				class: 'panel-navigation-button',
				w: 120,
				h: 120
			}
		);

		$panel_buttons_navigation.append(this.$nav_button_left).append(this.$nav_button_right);

		this.$mg_container.append($panel_buttons_navigation);

		this.$nav_container = $nav;

		$right_panel
			.click({
				mg: this
			}, this.right_pressed)
			.mouseover({
				mg: this
			}, function (e) {
				e.data.mg.$nav_button_right.css({
					'opacity': 1
				});
			})
			.mouseout({
				mg: this
			}, function (e) {
				e.data.mg.$nav_button_right.css({
					'opacity': 0.2
				});
			});


		$left_panel.click({
			mg: this
		}, this.left_pressed)
			.mouseover({
				mg: this
			}, function (e) {
				e.data.mg.$nav_button_left.css({
					'opacity': 1
				});
			})
			.mouseout({
				mg: this
			}, function (e) {
				e.data.mg.$nav_button_left.css({
					'opacity': 0.2
				});
			});


		$nav.append($left_panel).append($right_panel);
		return ($nav);
	};
	this.init_buttons_navigation = function () {
		var left = jQuery('<div>', {
			class: 'lb_navigation_button left'
		});
		var right = jQuery('<div>', {
			class: 'lb_navigation_button right'
		});

		left.click({
			mg: this
		}, this.previous_event_handler);
		right.click({
			mg: this
		}, this.next_event_handler);

		this.$canvas.append(left).append(right);
	};
	this.init_controls = function () {

		var controls_array = [];
		//var num_buttons = 0;

		if (typeof this.settings.controls === 'boolean')
			this.$controls_container = this.$mg_container;
		else
			this.$controls_container = jQuery('<div>', {
				class: 'mind-controls-container'
			});

		this.$controls_container.addClass(this.settings.type + '-controls ' + this.settings.controls_position + '-controls ' + this.settings.controls_display);
		this.$controls_container.css('height', this.settings.button_height);

		this.$controls = jQuery('<div>', {
			class: 'mind-controls'
		});

		if (this.settings.posts_navigation && typeof $prev_button !== 'undefined')
			controls_array.push($prev_button);

		if (this.settings.thumbnails && this.settings.type != 'default') {
			let $collapse_button = this.mind_button_svg(Mg_Icons.thumbs, { class: 'mind-button' });
			$collapse_button.click({
				mg: this
			}, this.collapse_controls);
			controls_array.push($collapse_button);
		}
		this.$arrow_left = this.mind_button_svg(Mg_Icons.arrow_left, { class: 'mind-button' });
		this.$arrow_left.click({
			mg: this
		}, this.previous_event_handler);
		controls_array.push(this.$arrow_left);

		if (this.settings.counter) {
			this.$counter = jQuery('<div>', {
				class: 'mindfolio-counter'
			});
			this.$counter.css({
				'height': this.settings.button_height + 'px',
				'width': this.settings.button_width + 'px',
				'lineHeight': this.settings.button_height + 'px'
			});
			controls_array.push(this.$counter);
		}



		this.$arrow_right = this.mind_button_svg(Mg_Icons.arrow_right, { class: 'mind-button' });
		this.$arrow_right.click({
			mg: this
		}, this.next_event_handler);
		controls_array.push(this.$arrow_right);

		this.$pause_button = this.mind_button_svg(Mg_Icons.pause, { class: 'mind-button' });
		this.$pause_button.click({
			mg: this
		}, this.stop);
		controls_array.push(this.$pause_button);

		this.$zoom_button = this.mind_button_svg(Mg_Icons.zoom_out, { class: 'mind-button' });
		this.$zoom_button.click({
			mg: this
		}, this.zoom);
		controls_array.push(this.$zoom_button);

		if (this.settings.info_collapse) {
			var $info_container_collapse = this.mind_button_svg(Mg_Icons.info, { class: 'mind-button' });

			$info_container_collapse.click(toggle_info_panel);
			controls_array.push($info_container_collapse);
		}

		if (this.settings.posts_navigation && typeof $next_button !== 'undefined')
			controls_array.push($next_button);


		for (var i = 0; i < controls_array.length; i++) {
			this.$controls.append(controls_array[i]);
		}
		var controls_array_length = controls_array.length;
		if (this.settings.posts_navigation && typeof $prev_button !== 'undefined')
			controls_array_length -= 2;

		this.$controls.width(controls_array_length * this.settings.button_width);

		this.$controls_container.append(this.$controls);
		this.$mg_container.prepend(this.$controls_container);

		if (!this.settings.autoplay)
			this.stop();
	};




	this.init_info_panel = function () {

		if (this.settings.info_collapse) {

			this.$info_container.addClass('info-panel');

			init_info_panel();
		}

		if (this.settings.mg_desc)
			this.$info_container.append('<p>' + this.settings.mg_desc + '</p>');

		this.$item_desc_container = jQuery('<div>', {
			class: 'mind-item-desc'
		});
		this.$info_container.append(this.$item_desc_container);
	};

	this.mind_resized = function (event) {

		var mg = (event) ? event.data.mg : this;
		mg.prepare_item(mg, mg.current_item_id);

		if (mg.settings.type == 'background') {
			mg.$mg_container.width(mg.$mg_container.parent().width());
			mg.$mg_container.height(mg.$mg_container.parent().height());
		}

		var h = mg.$mg_container.height();
		var w = mg.$mg_container.width();

		if (mg.settings.controls && mg.settings.type != 'default')
			mg.place_controls(mg);
		if (mg.$nav_container) {
			mg.$nav_container.css({
				'width': w,
				'height': h
			});
			mg.$nav_container.children().css({
				'width': w / 2,
				'height': h
			});
		}
	};


	this.zoom = function (event) {
		var mg = event.data.mg;
		var c_i = mg.current_item_id;
		//var $item = mg.$Shelf_array[c_i];

		if (mg.settings.image_size == 'all_cover') {
			mg.settings.image_size = 'all_visible';
			setCookie('image_size', 'all_visible');
		} else {
			mg.settings.image_size = 'all_cover';
			setCookie('image_size', 'all_cover');
		}
		mg.prepare_item(mg, c_i, true);

	};
	this.collapse_mind_panel = function (event) {

		var mg = event.data.mg;
		var $panel = event.data.panel;

		if (event.data.controller == 'info_container_onscreen') {
			if (mg.info_container_onscreen) {
				$panel.velocity({
					'left': -1 * ($panel.width() + parseInt($panel.css('paddingLeft')) + parseInt($panel.css('paddingRight')))
				});
				mg.info_container_onscreen = false;
				setCookie('info_container_onscreen', 'false');
				mg.$info_container_collapse.removeClass('onscreen');
				mg.$info_container_collapse.find('span').velocity({
					'opacity': 1
				});
			} else {
				$panel.velocity({
					'left': 0
				});
				mg.info_container_onscreen = true;
				setCookie('info_container_onscreen', 'true');
				mg.$info_container_collapse.addClass('onscreen');
				mg.$info_container_collapse.find('span').velocity({
					'opacity': 0
				});
			}
		} else if (event.data.controller == 'info_image_onscreen') {
			if (mg.info_image_onscreen) {
				$panel.velocity({
					'right': 0
				});
				mg.info_image_onscreen = false;
			} else {
				$panel.velocity({
					'right': jQuery(window).width()
				});
				mg.info_image_onscreen = true;
			}
		}
	};


	this.thumb = function (mg, i) {

		this.$thumb = jQuery(mg.$thumbnails[i]);
		//this.$thumb.width(mg.settings.thumbs_width);
		//this.$thumb.height(mg.settings.thumbs_height);
		this.$thumb.css({
			width: mg.settings.thumbs_width,
			height: mg.settings.thumbs_height
		});

		//console.log('vyska thumb je ' + this.$thumb.width());


		var $thumb = this.$thumb;

		this.$img = jQuery(this.$thumb.find('img'));

		this.$img.width(this.$img.attr('width'));
		this.$img.height(this.$img.attr('height'));


		var s = mg.resize_image(this.$img, 'all_cover', $thumb);
		this.$img.width(s.width);
		this.$img.height(s.height);
		center_element(this.$img, $thumb, true, true, false);

		this.$top_border = jQuery('<div>', {
			class: 'top border'
		});
		this.$bottom_border = jQuery('<div>', {
			class: 'bottom border'
		});

		this.$thumb.append(this.$top_border).append(this.$bottom_border);

		this.$top_border.css('width', mg.settings.thumbs_width);
		this.$bottom_border.css('width', mg.settings.thumbs_width);



		this.order = i;
		this.mg = mg;

		this.get_focus = function (event) {
			let thumb = null;

			if (!event) {
				thumb = this;
			} else {
				thumb = event.data.thumb;
			}

			thumb.$top_border.stop().velocity({
				top: '0',
				height: '10px'
			}, 'fast');
			thumb.$bottom_border.stop().velocity({
				bottom: '0',
				height: '10px',
			}, 'fast');
		};
		this.lose_focus = function (event) {

			let thumb = null;

			if (!event) {
				thumb = this;
			} else {
				thumb = event.data.thumb;
			}

			thumb.$top_border.stop().velocity({
				top: '0',
				height: '0'
			}, 'fast');
			thumb.$bottom_border.stop().velocity({
				bottom: '0',
				height: '0',
			}, 'fast');
		};


		this.show_image = function (mg, order) {

			if (mg.settings.thumbnails && mg.settings.type != 'lightbox') {
				mg.thumbnails_array[mg.current_item_id].activate();
				mg.thumbnails_array[order].get_focus();
				mg.thumbnails_array[order].deactivate();
			}

			mg.show_item(order, mg);
		};


		this.activate = function () {
			this.lose_focus();
			this.$thumb
				.mouseover({
					thumb: this
				}, this.get_focus)
				.mouseout({
					thumb: this
				}, this.lose_focus)
				.click({
					thumb: this
				}, this.thumb_clicked);
		};
		this.deactivate = function () {
			this.$thumb.unbind();
		};
		this.thumb_clicked = function (event) {
			event.preventDefault();
			var mg = event.data.thumb.mg;
			var order = event.data.thumb.order;
			event.data.thumb.show_image(mg, order);
		};

	};


	this.place_controls = function (mg) {

		var container_width = mg.$mg_container.width();

		var thumbs_row_space = Math.floor(container_width / mg.settings.thumbs_width);
		var thumbs_rows = Math.ceil(mg.$Shelf_array.length / thumbs_row_space);
		mg.thumbs_holder_height = mg.settings.thumbs_height * thumbs_rows;

		if (mg.thumbnails_array.length > thumbs_row_space)
			mg.thumbs_holder_width = thumbs_row_space * mg.settings.thumbs_width;
		else
			mg.thumbs_holder_width = mg.thumbnails_array.length * mg.settings.thumbs_width;


		mg.$thumbnails_holder.css('width', mg.thumbs_holder_width + 'px');

		if (mg.settings.controls && mg.settings.controls_position == 'center') {
			center_element(mg.$thumbnails_holder, mg.$thumbnails_container, true, false);
			center_element(mg.$controls, false, true, false);
		}



		if (!mg.controls_collapsed)
			mg.$controls.css('bottom', mg.thumbs_holder_height);
		else
			mg.$thumbnails_holder.css('bottom', -mg.thumbs_holder_height);

	};

	/* *************************************************************************
	 *	resize_image(img, size, parent)
	 *
	 *	img:	html image tag 
	 *  size:	string (all_cover, all_visible, no_scale)
	 *  parent: jQuery object of parent div. If not set, canvas_container is used instead
	 *   	
	 *	returns:	object{width, height} Object with new proportions
	 ************************************************************************* */
	this.resize_image = function (img, size, parent) {

		if (typeof parent === 'undefined') {
			parent = this.$canvas;

		}


		var w = parent.width();
		var h = parent.height();

		var i_w = null;
		var i_h = null;

		if (typeof img === 'object') {
			i_w = img.width();
			i_h = img.height();
		} else {
			i_w = img.width;
			i_h = img.height;
		}

		var w_dif = w / i_w;
		var h_dif = h / i_h;

		var n_w = 0;
		var n_h = 0;

		img = jQuery(img);

		switch (size) {
		case 'all_cover':
			if (w_dif > h_dif) {
				n_w = Math.round(i_w * w_dif);
				n_h = Math.round(i_h * w_dif);
			} else {
				n_w = Math.round(i_w * h_dif);
				n_h = Math.round(i_h * h_dif);
			}
			return {
				width: n_w, height: n_h
			};
			//break;
		case 'all_visible':
			if (w_dif > h_dif) {
				n_w = Math.round(i_w * h_dif);
				n_h = Math.round(i_h * h_dif);
			} else {
				n_w = Math.round(i_w * w_dif);
				n_h = Math.round(i_h * w_dif);
			}
			return {
				width: n_w, height: n_h
			};

			//break;
		case 'no_scale':
			//console.log('fgdfgdfgdfgd  '+h+'   '+i_h);

			if (w_dif < 1 || h_dif < 1) {
				if (w_dif > h_dif) {
					n_w = Math.round(i_w * h_dif);
					n_h = Math.round(i_h * h_dif);
				} else {
					n_w = Math.round(i_w * w_dif);
					n_h = Math.round(i_h * w_dif);
				}
			} else {
				n_w = i_w;
				n_h = i_h;
			}

			return {
				width: n_w, height: n_h
			};
			//break;			
		}
	};
	this.swap_image = function (img) {

		if (this.settings.type == 'lightbox' && this.$nav_container) {
			this.$nav_container.children().width(jQuery(img).width() / 2);
		}

		//var $inactive_layer = this.$inactive_layer;

		switch (this.settings.type) {
		case 'fullscreen':
			this.$active_layer.css('zIndex', -100);
			this.$inactive_layer.stop()
				.css('zIndex', -90)
				.empty()
				.append(img)
				.css('display', 'none')
				.fadeIn(800);
			if (this.settings.image_size != 'full_cover') {
				this.$active_layer.stop().fadeOut(800);
				center_element(jQuery(img), this.$inactive_layer, true, true, false);
			}
			this.$inactive_layer = this.$active_layer;
			this.$active_layer = next_image;
			break;
		case 'lightbox':

			this.$active_layer.css('zIndex', -100);
			this.$inactive_layer
				.stop()
				.css('zIndex', -90)
				.empty()
				.append(img)
				.css('display', 'none')
				.fadeIn(800);
			if (this.settings.image_size != 'full_cover') {
				this.$active_layer
					.stop()
					.fadeOut(800);
				center_element(jQuery(img), this.$inactive_layer, true, true, false);
			}
			this.$inactive_layer = this.$active_layer;
			this.$active_layer = next_image;

			break;

		case 'mobile':
			break;

		}


	};
	this.prepare_item = function (mg, order, animate) {

		animate = (typeof animate === 'undefined' ? false : true);

		var $item = mg.$Shelf_array[order];
		var $img = $item.$img;

		if ($img.width() == 0) {
			$img.width($item.attr('width')).height($item.attr('height'));
		}

		switch (mg.settings.type) {
		case 'background':

			jQuery($img.parent()).width(mg.$window.width()).height(mg.$window.height());
			mg.$canvas.width(mg.$window.width()).height(mg.$window.height());

			break;
		case 'default':
			mg.$canvas.height(mg.$mg_container.height());
			mg.$canvas.width(mg.$mg_container.width());
			break;
		case 'lightbox':


			break;
		}

		var s = mg.resize_image($img, mg.settings.image_size, mg.$canvas);
		var res = null;
		if (mg.settings.items_position == 'center')
			res = this.center_element($img, mg.$canvas, true, true, s);
		else
			res = this.center_element($img, mg.$canvas, false, true, s);
		if (animate) {
			$img.velocity(res, function () {
				mg.make_scrollable();
			});
			if ($item.$img_thumb)
				$item.$img_thumb.velocity(res);
		} else {
			$img.css(res);
			mg.make_scrollable();
			if ($item.$img_thumb)
				$item.$img_thumb.css(res);
		}

		var c = mg.center_element($item.$preloader, false, true, true, false);
		$item.$preloader.css(c);

		return $item;

	};



	this.load_image = function ($item, $img, order) {

		const mg = this;

		this.loading = true;
		if (this.next_item_to_load == order)
			this.next_item_to_load = false;

		if ($item.$preloader.status != 'rotating') {
			$item.$preloader.status = 'rotating';

			var c = mg.center_element($item.$preloader, false, true, true, false);
			$item.$preloader.css(c);

			$item.progress = 'loading';

			$item.$preloader.angle = 0;
			$item.$preloader.preloader_int = setInterval(function () {
				$item.$preloader.angle += 5;
				$item.$preloader.rotate($item.$preloader.angle);
			}, 30);
		}


		$img.load(function () {
			mg.loading = false;
			$item.progress = 'loaded';

			clearInterval($item.preloader_int);
			$item.$preloader.css('display', 'none');

			if (!mg.loading) {
				if (mg.next_item_to_load)
					mg.prepare_item(mg, mg.next_item_to_load, false);
				else {
					var n_id = mg.get_next_unloaded_item(order);
					if (n_id)
						mg.prepare_item(mg, n_id, false);
				}
			}


			setTimeout(function () {
				mg.$init_blank_window.fadeOut();
			}, 500);
		});

		$img.attr('src', $item.attr('src'));
		$img.attr('srcset', $item.attr('srcset'));
		$img.attr('sizes', $item.attr('sizes'));
	};

	this.get_next_unloaded_item = function (order) {
		for (var i = order; i < this.$Shelf.length; i++) {
			if (this.$Shelf_array[i].$item.progress != 'loaded') {
				return i;
			}
		}
		for (var n = order; n > 0; n--) {
			if (this.$Shelf_array[i].progress != 'loaded') {
				return i;
			}
		}
		return false;
	};
	this.make_scrollable = function (mg) {
		if (!mg)
			mg = this;
		mg.$window.unbind('mousewheel');
		var $item = mg.SuperLoader.$currently_viewed_item;
		var $image = jQuery($item.$img);
		//console.log($image);

		//var p_w = mg.$canvas.width();
		var p_h = mg.$canvas.height();
		//var i_w = $image.width();
		var i_h = $image.height();

		//console.log(p_h + ', ---, '+i_h);

		mg.$window.bind('mousewheel', function (event) {

			if (i_h > p_h) {

				var $t = parseInt($image.css('top'));
				//console.log($image);
				$t += event.deltaY * 200;
				if (-1 * ($t - p_h) > i_h) {
					$t = -1 * (i_h - p_h);

				} else if ($t > 0) {
					$t = 0;
				}
				$image.stop().animate({
					'top': $t
				}, 'slow', 'easeOutCubic');
			}

		});

	};

	this.show_item = function (order, mg) {

		let $item = null;


		if (mg.settings.posts_navigation && typeof $next_button !== 'undefined' && typeof $prev_button !== 'undefined') {
			if (mg.event == 'next_link_reached') {
				mind_hide_link($next_button);
				clearTimeout(mg.timer_link);
			}
			if (mg.event == 'prev_link_reached') {
				mind_hide_link($prev_button);
				clearTimeout(mg.timer_link);
			}

			if (typeof mg.current_item_id !== 'undefined') {
				if (mg.current_item_id < order /*&& mg.current_item_id != 0*/ && order + 1 == mg.$Shelf.length) {
					mind_show_link($next_button);
					mg.event = 'next_link_reached';
				} else if (mg.current_item_id > order /*&& mg.current_item_id+1 != mg.$Shelf.length*/ && order == 0) {
					mind_show_link($prev_button);
					mg.event = 'prev_link_reached';
				} else mg.event = '';
			}
		}

		$item = mg.$Shelf_array[order];

		if (mg.settings.items_autosize) {
			var item_proportions = $item.attr('width') / $item.attr('height');
			var mg_proportions = mg.$canvas.width() / mg.$canvas.height();

			if (mg_proportions > 1 && item_proportions < 1 || mg_proportions < 1 && item_proportions > 1)
				mg.settings.image_size = 'all_visible';
			else
				mg.settings.image_size = 'all_cover';
		}

		mg.next_item_to_load = order;


		/***------------------------------------------------------------------*/
		if (mg.settings.type != 'lightbox') {
			var $layer_to_show = mg.$inactive_layer;
			var $layer_to_hide = mg.$active_layer;

			mg.$active_layer.css('zIndex', mg.z_index_bottom).fadeOut(800);
			mg.$inactive_layer
				.stop()
				.css('zIndex', mg.z_index_top)
				.empty()
				.append($item)
				.css('display', 'none')
				.fadeIn(800);

			mg.$inactive_layer = $layer_to_hide;
			mg.$active_layer = $layer_to_show;
		} else {
			var $c_item = mg.$Shelf_array[mg.current_item_id]; // first shown item

			var swipe_size = mg.$canvas.width();

			if (mg.lightbox_collapsed)
				mg.shutup();

			if (mg.$active_layer.hasClass('water')) {
				mg.$left_layer = mg.$lb_layer_earth;
				mg.$right_layer = mg.$lb_layer_air;
			} else if (mg.$active_layer.hasClass('air')) {
				mg.$left_layer = mg.$lb_layer_water;
				mg.$right_layer = mg.$lb_layer_earth;
			} else if (mg.$active_layer.hasClass('earth')) {
				mg.$left_layer = mg.$lb_layer_air;
				mg.$right_layer = mg.$lb_layer_water;
			}



			if (mg.direction == 'left') {
				mg.$right_layer.css('left', -1 * swipe_size);
				mg.$active_layer.stop().velocity({
					'left': swipe_size
				}, function () {
					$c_item.append($c_item.$layer);
				});
				mg.$left_layer.empty().append($item.$layer).css('left', -1 * swipe_size).stop().velocity({
					'left': 0
				});

				mg.$active_layer = mg.$left_layer;
			} else if (mg.direction == 'right') {
				mg.$left_layer.css('left', swipe_size);
				mg.$active_layer.velocity({
					'left': -1 * swipe_size
				}, function () {
					$c_item.append($c_item.$layer);
				});
				mg.$right_layer.empty().append($item.$layer).css('left', swipe_size).stop().velocity({
					'left': 0
				});

				mg.$active_layer = mg.$right_layer;
			} else if (mg.direction == '') {
				$c_item.append($c_item.$layer);
				mg.$lb_layer_water.empty().append($item.$layer);
				mg.$active_layer = mg.$lb_layer_water;
			} else
				mg.error('problem with lightbox direction recognition.');
		}


		mg.SuperLoader.item_viewed($item);

		$item = mg.prepare_item(mg, order);


		mg.current_item_id = order;


		if (mg.settings.info != false && this.$item_desc_container)
			this.$item_desc_container.html('<h2>' + mg.$Shelf_array[order].name + '</h2><p> ' + mg.$Shelf_array[order].desc + '</p>');
		if (mg.player == true) {
			mg.autoplay();
		}
		if (mg.settings.controls && mg.settings.counter)
			mg.$counter.html(mg.current_item_id + 1 + '/' + mg.$Shelf.length);
	};

	this.next_image = function (mg) {
		mg.direction = 'right';
		if (mg.children.length == 1) {
			window.location.href = next_url;
			return;
		}

		if (mg.event == 'next_link_reached') {
			window.location.href = next_url;
			return;
		}

		var i = parseInt(mg.current_item_id);
		var next = i + 1 < (mg.$Shelf.length) ? i + 1 : 0;

		if (mg.settings.thumbnails && mg.settings.type != 'lightbox') {
			mg.thumbnails_array[i].activate();
			mg.thumbnails_array[next].get_focus();
			mg.thumbnails_array[next].deactivate();
		}

		mg.show_item(next, mg);
	};
	this.previous_image = function (mg) {
		mg.direction = 'left';
		if (mg.children.length == 1) {
			window.location.href = prev_url;
			return;
		}

		if (mg.event == 'prev_link_reached') {
			window.location.href = prev_url;
			return;
		}

		var i = mg.current_item_id;
		var next = i > 0 ? i - 1 : mg.$Shelf.length - 1;
		if (mg.settings.thumbnails && mg.settings.type != 'lightbox') {
			mg.thumbnails_array[i].activate();
			mg.thumbnails_array[next].get_focus();
			mg.thumbnails_array[next].deactivate();
		}
		mg.show_item(next, mg);
	};
	this.left_pressed = function (event) {
		var mg = event.data.mg;
		mg.previous_image(mg);
	};
	this.right_pressed = function (event) {
		var mg = event.data.mg;
		mg.next_image(mg);
	};

	this.keypressed = function (event) {
		var mg = event.data.mg;
		switch (event.which) {
		case 37: //left
			mg.previous_image(mg);
			break;
		case 39: //right
			mg.next_image(mg);
			break;
		case 27: //esc
			if (mg.settings.type == 'lightbox') {
				mg.shutdown();
			}
			break;
		default:
			return;
		}
	};
	this.lightbox_keypressed = function (e) {
		var mg = e.data.mg;
		if (!mg.lightbox_collapsed) {
			switch (e.which) {
			case 37: //left
				mg.previous_image(mg);
				break;
			case 39: //right
				mg.next_image(mg);
				break;
			case 27: //esc
				mg.shutdown();
				break;
			default:
				return;
			}
		}

	};
	this.next_event_handler = function (event) {
		event.data.mg.next_image(event.data.mg);
	};
	this.previous_event_handler = function (event) {
		event.data.mg.previous_image(event.data.mg);
	};
	this.collapse_controls = function (event) {
		var mg = event.data.mg;
		if (mg.controls_collapsed) {
			mg.$controls_container.velocity({
				'bottom': mg.thumbs_holder_height + 'px'
			});
			mg.$thumbnails_holder.velocity({
				'bottom': 0 + 'px'
			});
			mg.controls_collapsed = false;
		} else {
			mg.$controls_container.velocity({
				'bottom': '0px'
			});
			mg.$thumbnails_holder.velocity({
				'bottom': -mg.thumbs_holder_height + 'px'
			});
			mg.controls_collapsed = true;
		}
	};

	this.mind_button_svg = function (svg_st, params) {

		const el = document.createElement('div');
		const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
		const w = params.w ? params.w : this.settings.button_width;
		const h = params.h ? params.h : this.settings.button_height;

		svg.classList.add('mind-nav-icon-svg');
		svg.setAttribute('version', '1.1');
		svg.setAttribute('x', '0px');
		svg.setAttribute('y', '0px');
		svg.setAttribute('width', w + 'px');
		svg.setAttribute('height', h + 'px');
		svg.setAttribute('xml:space', 'preserve');
		svg.setAttribute('viewBox', '0 0 30 30');
		svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');

		svg.innerHTML = svg_st;

		el.appendChild(svg);
		el.classList.add(params.class ? params.class : '');

		return jQuery(el);
	};

	this.mind_button = function (classname, width, height, img) {

		if (!width)
			width = this.settings.button_width;
		if (!height)
			height = this.settings.button_height;

		var $btn = jQuery('<div>', {
			class: 'mind-button ' + classname
		});
		$btn.css({
			'width': width,
			'height': height
		});

		if (img && typeof img === 'string')
			$btn.append(jQuery('<img>', {
				src: img
			}));

		return $btn;


	};
	this.mind_button_hover = function (event) {
		var btn = event.data.btn;
		jQuery(btn.find('.inner')).stop().fadeIn();
	};
	this.mind_button_hovout = function (event) {
		var btn = event.data.btn;
		jQuery(btn.find('.inner')).stop().fadeOut();
	};

	this.show_random_image = function () {
		//var random_image = Math.round(Math.random() * this.children.length);
	};
	this.autoplay = function () {

		var mg = this;
		clearTimeout(this.playback_interval);
		this.playback_interval = undefined;

		this.playback_interval = setTimeout(function () {
			mg.next_image(mg);
		}, mg.settings.autodelay);
	};
	this.play = function (event) {
		var mg = event ? event.data.mg : this;
		mg.player = true;

		if (mg.settings.controls) {
			mg.$pause_button
				.removeClass('mind-play')
				.addClass('mind-pause')
				.unbind()
				.click({
					mg: mg
				}, mg.stop);
		}

		mg.autoplay();
	};
	this.stop = function (event) {
		var mg = event ? event.data.mg : this;
		mg.player = false;

		if (mg.settings.controls != false) {
			mg.$pause_button
				.removeClass('mind-pause')
				.addClass('mind-play')
				.unbind()
				.click({
					mg: mg
				}, mg.play);
		}
		clearTimeout(mg.playback_interval);
	};
	this.center_element = function ($element, $parent, horizontal, vertical, sizes) {
		if (!$parent) {
			$parent = $element.parent();

		}
		var new_dimensions = {};
		if (horizontal) {
			var e_w = null;
			var p_w = null;
			var l = null;
			if (!sizes)
				e_w = $element.width();
			else
				e_w = sizes.width;
			p_w = $parent.width();

			l = (p_w - e_w) / 2;

			new_dimensions.left = l;

		}
		if (vertical) {

			var e_h = null;
			if (!sizes) {
				e_h = $element.height();
			} else {
				e_h = sizes.height;
			}
			var p_h = $parent.height();

			var t = (p_h - e_h) / 2;

			new_dimensions.top = t;

			if (sizes) {
				new_dimensions.width = sizes.width;
				new_dimensions.height = sizes.height;
			}
		}

		return (new_dimensions);
	};

	this.ui_switcher_handler = function () {
		var mg = this;
		var ui_switcher = {};
		ui_switcher.x = 0;
		ui_switcher.y = 0;
		ui_switcher.prev_x = 0;
		ui_switcher.prev_y = 0;
		ui_switcher.counter = 0;
		ui_switcher.state = true;

		jQuery(window).mousemove({
			ui_switcher: ui_switcher
		}, function (e) {
			var ui_switcher = e.data.ui_switcher;
			ui_switcher.x = e.pageX;
			ui_switcher.y = e.pageY;
		});

		this.ui_switcher_int = setInterval(function () {

			if (ui_switcher.prev_x == ui_switcher.x && ui_switcher.prev_y == ui_switcher.y) {
				ui_switcher.counter++;
				if (ui_switcher.counter == 10) {
					ui_switcher.state = false;
					mg.hide_ui();
				}
			} else {
				if (ui_switcher.state == false) {
					ui_switcher.state = true;
					mg.show_ui();
				}
				ui_switcher.counter = 0;
			}
			ui_switcher.prev_x = ui_switcher.x;
			ui_switcher.prev_y = ui_switcher.y;

		}, 250);
	};

	this.hide_ui = function () {
		jQuery('#mindfolio-header').stop().velocity({
			'top': -50
		});
		jQuery('.mind-controls-container').stop().velocity({
			'bottom': -50
		});

		if (this.info_container_onscreen)
			this.collapse_mind_panel({
				data: {
					mg: this,
					controller: 'info_container_onscreen',
					panel: this.$info_container
				}
			});
	};
	this.show_ui = function () {
		jQuery('#mindfolio-header').velocity({
			'top': 0
		});
		jQuery('.mind-controls-container').stop().velocity({
			'bottom': 0
		});
	};


	this.error = function (message) {
		return message;
		//console.log(message);
	};
}